import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { PositionService } from 'app/views/appviews/quote/position.service';
import { IDtoCommission } from 'app/shared/models/position/dto-commission.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';

@Component({
    selector: 'app-modal-commission',
    styleUrls: ['./modal-commission.style.scss'],
    templateUrl: './modal-commission.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalCommissionComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formCommission: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    private customerId: number;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    
    /**Listas */
    private commissions = new Array() as IDtoCommission[];
    private catalogCustomerCommissions: Observable<IDtoCatalog[]>;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private configGeneral: AppConfig
        , private positionService: PositionService) {
        this.initializeFormRiskPremium();
    }
    ngOnInit(): void {
        this.onClose = new Subject();
        this.catalogCustomerCommissions = this.positionService.getCatalogFixedCustomerCommissionsByCustomerId(this.customerId);
    }
    private initializeFormRiskPremium() {
        this.formCommission = this.formBuilder.group({
            //name: [null, [Validators.required, Validators.maxLength(50)]],
            value: [null, [Validators.required]],
            percentage: [null, [Validators.required]],
            maxValue: [null],
            customerCommissionId: [null, [Validators.required]]
        });
    }
    private resetForm(): void {
        this.formCommission.reset();
    }
    private submit(): void {
        if (this.formCommission.valid) {
            let c = this.formCommission.value as IDtoCommission;
            c.percentage = Number(c.percentage);
            c.maxValue = Number(c.maxValue);
            c.value = Number(c.value);
            let exist = this.commissions.filter(e => e.customerCommissionId == c.customerCommissionId);
            if (exist.length > 0) {
                this.configGeneral.newToast('Validación', 'La comisión que intenta agregar ya existe', 'warning');
                return;
            }
            this.catalogCustomerCommissions.subscribe(catalog =>{
                c.name = catalog.filter(v => v.id == c.customerCommissionId)[0].name;
                this.commissions.push(c);
                this.commissions = [...this.commissions];
                this.resetForm();
            });
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.configGeneral.touchedControls(this.formCommission);
        }
    }
    private remove(item: IDtoCommission): void {
        if (item.id > 0) {
            this.deleteCommission(item);
        } else {
            let index = this.commissions.indexOf(item)
            if (index > -1) {
                this.commissions.splice(index, 1);
                this.commissions = [...this.commissions];
            }
        }
    }
    private deleteCommission(item: IDtoCommission): void {
        this.positionService.deleteCommission(item.id).subscribe(x => {
            if(x.isCorrect) {
                let index = this.commissions.indexOf(item)
                if (index > -1) {
                    this.commissions.splice(index, 1);
                    this.commissions = [...this.commissions];
                }
            } else {
                this.configGeneral.newToast('Error', x.message, 'error');
            }
        });
    }
    private close(): void {
        this.onClose.next(this.commissions);
        this.bsModalRef.hide();
    }
    private calculateMaxValue() {
        let c = this.formCommission.value as IDtoCommission;
        let res = Math.round((c.percentage * c.value / 100) * 30);
        this.formCommission.get('maxValue').setValue(res);
    }
}
